import { z } from "zod";
import { AgentTypeMetadata } from "../../config/agent-registry";
import { baseAgentConfig } from "../../config/base-agent-config";

const sqlConfigSchema = baseAgentConfig.extend({
  dbServer: z.string().min(1, "Database server is required"),
  dbDatabase: z.string().min(1, "Database name is required"),
  dbUsername: z.string().min(1, "Username is required"),
  dbPassword: z.string().min(1, "Password is required"),
  dbPort: z
    .coerce.number()
    .int()
    .min(1)
    .max(65535, "Port must be between 1 and 65535"),
});

export const sqlAgentMetaData: AgentTypeMetadata<typeof sqlConfigSchema> = {
  name: "Microsoft SQL Database",
  description:
    "Microsoft SQL Server database integration for querying and analyzing data",
  category: "Database",
  icon: "database",
  type: "agent",
  version: "Released",
  ribbon: null,
  status: "Active",
  href: "/admin/ai-configuration/connectors/sql",
  instructions: `You are a SQL Database Agent. Help users query SQL Server databases safely and efficiently.

**WORKFLOW:**
1. ALWAYS use getSchemaInfoTool first to fetch current database schema
2. Build appropriate SELECT queries based on schema and user questions
3. Execute queries using executeQueryTool
4. Provide clear results and explanations

**TOOLS:**
- getSchemaInfoTool: Get database schema (tables, columns, relationships)
- executeQueryTool: Execute safe SELECT queries
- analyzeQueryTool: Analyze query performance
- selectSQLConnectionTool: Choose database connection

**RULES:**
- Only SELECT queries allowed (no INSERT, UPDATE, DELETE)
- Always fetch schema before writing queries
- Explain query logic clearly
- Format results in readable tables`,
  placeholders: {
    dbServer: "localhost",
    dbDatabase: "your_database_name",
    dbUsername: "database_user",
    dbPassword: "Enter database password",
    dbPort: "1433",
  },
  configSchema: sqlConfigSchema,
  workflows: [
    {
      id: "mssqlSchemaEmbeddingWorkflow",
      name: "MSSQL Schema Embedding",
      description:
        "Embed MSSQL database schema information into the vector store for enhanced search capabilities",
      triggerLabel: "Embed Data",
    },
  ],
  sensitiveKeys: ["dbPassword"],
};
